import { memo } from "react"

export const IconCheck = memo(() => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#fff" />
      <g clip-path="url(#a)">
        <path d="M6.286 10.4 3.886 8l-.8.8 3.2 3.2 6.857-6.856-.8-.8z" fill="#E5E5E5" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M1.143 1.145h13.714v13.714H1.143z" />
        </clipPath>
      </defs>
    </svg>
  )
})

export const IconCheckComplete = memo(() => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradient-check" x1="11.394" y1="5.091" x2="2.182" y2="8.242" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6729EA" />
          <stop offset="1" stopColor="#002C98" />
        </linearGradient>
        <clipPath id="clip-check">
          <path fill="#fff" d="M1.143 1.145h13.714v13.714H1.143z" />
        </clipPath>
      </defs>
      <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8" fill="url(#gradient-check)" />
      <g clipPath="url(#clip-check)">
        <path d="M6.286 10.4 3.886 8l-.8.8 3.2 3.2 6.857-6.856-.8-.8z" fill="#fff" />
      </g>
    </svg>
  )
})

export const IconCheckGreen = memo(() => {
  return (
    <svg
      className="icon-check-green"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m3.111-10.828a.8.8 0 1 1 1.132 1.131l-4.526 4.526a.8.8 0 0 1-1.131 0L3.757 8A.8.8 0 0 1 4.89 6.869L7.15 9.13z"
        fill="#1EA672"
      />
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
})
